<template>
    <div class="PercentageChangeBar">
        <div :class="classes" :style="styles"></div>
        <div :class="figureClasses" v-html="displayFigure"></div>
    </div>
</template>

<script>
    export default {
        props: {
            change: {
                required: true,
                type: [Number, String],
            }
        },

        computed: {
            classes() {
                return {
                    'PercentageChangeBar__percentage': true,
                    'PercentageChangeBar__percentage--negative': this.change < 0,
                    'PercentageChangeBar__percentage--positive': this.change > 0,
                }
            },

            figureClasses() {
                return {
                    'PercentageChangeBar__figure': true,
                    'PercentageChangeBar__figure--negative': this.change < 0,
                    'PercentageChangeBar__figure--positive': this.change > 0,
                }
            },

            styles() {
                return 'width:' + this.figure / 2 + 'px';
            },

            figure() {
                return Math.abs(this.change).toFixed(2);
            },

            displayFigure() {
                if (typeof this.change === 'string') return '-';

                return this.sign + this.figure + '%';
            },

            sign() {
                if (this.change == 0) return '';

                return this.change > 0 ? '' : '&minus;';
            }
        }
    }
</script>